import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { adminApi } from '../../api/admin';
import { GQLArgs } from '../../types';

type ResyncResponse = { resyncAll: { message: string } };

export const useMutationResync = (args?: GQLArgs<ResyncResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ResyncResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables?: { organizationSlug?: string } } = {}) => {
      setLoading(true);
      try {
        const res = variables?.organizationSlug
          ? await adminApi.resyncOne(variables.organizationSlug)
          : await adminApi.resyncAll();
        const shaped: ResyncResponse = { resyncAll: { message: res.data.message } };
        setData(shaped);

        // Show success toast message
        toast.success(res.data.message, {
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });

        args?.onCompleted?.(shaped);
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
